<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="mr-2">
          <b-button v-if="
            routeName == 'rrhh-payroll-payments' &&
            subTab == 'rrhh-payroll-payments-operations'
          " v-b-tooltip.hover.left="$t('Calculate Fortnight')" v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-primary" class="mr-1" @click="calculateDriverPayroll">
            <div class="d-flex justify-content-between">
              <tabler-icon icon="TruckIcon" class="mr-1" />
              <span v-t="'Fortnight'"></span>
            </div>
          </b-button>

          <b-button v-if="
            routeName == 'rrhh-payroll-payments' &&
            subTab == 'rrhh-payroll-payments-operations'
          " v-b-tooltip.hover.left="$t('Calculate Payroll')" v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success" @click="calculateEndOfMonthDriverPayroll">
            <div class="d-flex justify-content-between">
              <tabler-icon icon="TruckIcon" class="mr-1" />
              <span v-t="'Payroll'"></span>
            </div>
          </b-button>

          <b-button v-if="
            routeName == 'rrhh-payroll-payments' &&
            subTab == 'rrhh-payroll-payments-administrative'
          " v-b-tooltip.hover.left="$t('Calculate Fortnight')" v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-primary" class="mr-1" @click="calculateEmployeePayroll">
            <div class="d-flex justify-content-between">
              <tabler-icon icon="UsersIcon" class="mr-1" />
              <span v-t="'Fortnight'"></span>
            </div>
          </b-button>

          <b-button v-if="
            routeName == 'rrhh-payroll-payments' &&
            subTab == 'rrhh-payroll-payments-administrative'
          " v-b-tooltip.hover.left="$t('Calculate Payroll')" v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success" @click="calculateEmployeeMonthPayroll">
            <div class="d-flex justify-content-between">
              <tabler-icon icon="UsersIcon" class="mr-1" />
              <span v-t="'Payroll'"></span>
            </div>
          </b-button>

          <b-button v-if="routeName == 'rrhh-payroll-discounts'" v-b-tooltip.hover.right="$t('Register Discount')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="outline-success" @click="openModalDiscount">
            <div class="d-flex justify-content-between">
              <span> {{ $t("CREATE") }} </span>
            </div>
          </b-button>

          <b-button v-if="routeName == 'rrhh-payroll-salary-advance'"
            v-b-tooltip.hover.right="$t('Registrar adelanto de sueldo')" v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success" @click="openModalDiscount">
            <div class="d-flex justify-content-between">
              <span> {{ $t("CREATE") }} </span>
            </div>
          </b-button>

          <!-- <b-button
            v-if="routeName == 'rrhh-payroll-vacations'"
            v-b-tooltip.hover.right="$t('Programar vacaciones')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success"
            @click="openModalDiscount"
          >
            <div class="d-flex justify-content-between">
              <span> {{ $t("CREATE") }} </span>
            </div>
          </b-button> -->

          <b-button v-if="routeName == 'rrhh-payroll-gratifications'" v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success" @click="openModalGenerarGratificacion">
            <div class="d-flex justify-content-between">
              <span> GENERAR </span>
            </div>
          </b-button>

          <b-button v-if="['rrhh-payroll-cts', 'rrhh-payroll-bonos'].includes(routeName)"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="outline-success" @click="openModalGenerarCts">
            <div class="d-flex justify-content-between">
              <span> GENERAR </span>
            </div>
          </b-button>
        </div>
      </template>
    </header-slot>
    <b-nav card-header pills class="m-0">
      <b-nav-item v-for="(item, index) in tabs" :key="index" :to="{ name: item.name }" exact
        :active="item.name === routeName" exact-active-class="active" :link-classes="['px-3', bgTabsNavs]">{{ $t(item.title)
        }}
      </b-nav-item>
    </b-nav>
    <b-card no-body class="border-top-primary border-3 border-table-radius px-0">
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>
  </div>
</template>


<script>
import Ripple from "vue-ripple-directive";

import PayrollService from "@/views/rrhh/views/payroll/services/payroll.service.js";
import AdminPayrollService from "@/views/rrhh/views/payroll/services/administrative-payroll.service.js";

export default {
  components: {},
  directives: {
    Ripple,
  },
  data() {
    return {
      sidebarEmployee: false,
      filters: false,
    };
  },
  created() { },
  computed: {
    tabs() {
      const allTabs = this.$route.matched[1].meta.tabs || [];
      const userSections = this.$store.getters["auth/currentUser"].arr_sections || [];
      return allTabs.filter((tab) => {
        const targetRoute = this.$router.resolve({ name: tab.name }).route;
        const targetSection = targetRoute.meta?.section;

        if (!targetSection) return true; 

        return userSections.some(s => s.section_id == targetSection);
      });
    },
    routeName() {
      return this.$route.matched[2].name;
    },
    subTab() {
      return this.$route.matched[3].name;
    },
  },
  methods: {
    isActiveTab(tab) {
      // Logic replaced by checking item.name === routeName in template.
      return false;
    },

    async calculateDriverPayroll() {
      try {
        const { data } = await PayrollService.calculatePayroll({});
        this.$refs["routerViewTab"].refreshTable();
        this.showToastSuccess(data.msg);
      } catch (error) {
        console.log(error);
        this.showToastError(
          error?.response?.data?.message || error?.response?.data
        );
      }
    },

    async calculateEndOfMonthDriverPayroll() {
      try {
        this.addPreloader();
        const data = await PayrollService.calculateEndOfMonthPayroll({});
        this.$refs["routerViewTab"].refreshTable();
        console.log(data);
      } catch (error) {
        this.showToastError(error?.response?.data);
      } finally {
        this.removePreloader();
      }
    },

    async calculateEmployeePayroll() {
      //Planilla quincenal
      try {
        const data = await AdminPayrollService.calculatePayroll();
        this.$refs["routerViewTab"].refreshTable();
        this.showToastSuccess(data?.msg || "Planilla quincenal generada correctamente");
      } catch (error) {
        const errorData = error?.response?.data;
        const errorMsg = errorData?.message || errorData?.error || errorData;
        if (errorData?.empleados_sin_horario?.length) {
          const listaHtml = errorData.empleados_sin_horario
            .map(nombre => `<li class="text-left font-weight-bold">${nombre}</li>`)
            .join('');
          this.$swal({
            title: 'Trabajadores sin horario',
            html: `<div class="text-muted mb-1 text-left">No se puede calcular la planilla administrativa porque los siguientes trabajadores tienen control de asistencia activo pero <b>no tienen horario configurado</b>:</div><ul class="text-danger mb-1">${listaHtml}</ul><small class="text-muted">Por favor, configure sus horarios en el módulo de personal antes de calcular.</small>`,
            icon: 'warning',
            confirmButtonText: 'Entendido',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          });
        } else {
          this.showToastError(errorMsg);
        }
      }
    },

    async calculateEmployeeMonthPayroll() {
      //Planilla fin de mes
      try {
        const data = await AdminPayrollService.calculateMonthlyPayroll();
        this.$refs["routerViewTab"].refreshTable();
        this.showToastSuccess(data?.msg || "Planilla mensual generada correctamente");
      } catch (error) {
        const errorData = error?.response?.data;
        const errorMsg = errorData?.message || errorData?.error || errorData;
        if (errorData?.empleados_sin_horario?.length) {
          const listaHtml = errorData.empleados_sin_horario
            .map(nombre => `<li class="text-left font-weight-bold">${nombre}</li>`)
            .join('');
          this.$swal({
            title: 'Trabajadores sin horario',
            html: `<div class="text-muted mb-1 text-left">No se puede calcular la planilla administrativa mensual porque los siguientes trabajadores tienen control de asistencia activo pero <b>no tienen horario configurado</b>:</div><ul class="text-danger mb-1">${listaHtml}</ul><small class="text-muted">Por favor, configure sus horarios en el módulo de personal antes de calcular.</small>`,
            icon: 'warning',
            confirmButtonText: 'Entendido',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          });
        } else {
          this.showToastError(errorMsg);
        }
      }
    },

    openModalDiscount() {
      this.$refs["routerViewTab"].openModalDiscount();
    },
    openModalGenerarGratificacion() {
      this.$refs["routerViewTab"].openModalGenerarGratificacion();
    },
    openModalGenerarCts() {
      let operacion = 'cts';
      if (this.routeName == 'rrhh-payroll-bonos') {
        operacion = 'bonos';
      }
      if (this.routeName == 'rrhh-payroll-cts') {
        operacion = 'cts';
      }

      this.$refs["routerViewTab"].openModalGenerarCts(operacion);
    },
  },
};
</script>